import { Stack, Text } from '@zorro/web/design-system';

import { PaymentMethodType } from '../../../EmployeePage/EmployeePageContent/EmployeePageTabs/EmployeePaymentsTab/PaymentMethodType';
import { PaymentDetails } from '../../../Payments/PaymentDetails/PaymentDetails';
import { PaymentMethodViewer } from '../../../Payments/PaymentDetails/paymentMethodDisplayRules';

type Props = {
  sectionNumber: number;
  employeeId: string;
  employerId: string;
  onboardingPeriodId: string;
};

export const EnrollmentPaymentDetailsSection = ({
  sectionNumber,
  employeeId,
  employerId,
  onboardingPeriodId,
}: Props) => {
  return (
    <Stack mb="xl" ml="xs" gap="xxs">
      <Text w="100%" size="md" fw={600}>
        {sectionNumber}. Verify the payment details
      </Text>
      <Stack ml="md" gap="xl">
        <Text size="sm" c="var(--color-text-default-secondary)">
          Confirm the payment method on file before completing enrollment
        </Text>
        <PaymentMethodType
          employeeId={employeeId}
          onboardingPeriodId={onboardingPeriodId}
        />
        <PaymentDetails
          viewer={PaymentMethodViewer.OPS}
          employeeId={employeeId}
          employerId={employerId}
          onboardingPeriodId={onboardingPeriodId}
        />
      </Stack>
    </Stack>
  );
};
